export enum ValidateToken {
    IntervalDuration = 300000
}
